var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsInt, IsOptional, IsString, Max, MaxLength, Min } from 'class-validator';
import { Kontenrahmen, Versteuerungsart } from '../types/datev-enums.js';
/**
 * Body for `PATCH /office-location-datev-settings/:officeLocationId/kontenrahmen-steuerart`.
 *
 * Foldout 2 — "Kontenrahmen & Steuerart": Kontenrahmen, Sachkontenlänge and
 * Versteuerungsart.
 *
 * A Kontenrahmen swap resets `kontenMapping` to the new Kontenrahmen's
 * defaults. The frontend surfaces a confirm-modal warning before submitting
 * because Konten-customisations made on the previous Kontenrahmen are
 * discarded; the backend simply performs the reset.
 *
 * `versteuerungsart` swaps are not destructive and are recorded in the
 * DATEV-settings change history (PRD #1319 / RS-002); they change BU-Schlüssel
 * resolution from the next export onward.
 *
 * `gewinnermittlungsart` is deliberately NOT here (PRD #1319 / RS-004):
 * changing it retroactively re-books the practice's whole revenue history, so
 * it is served by a dedicated guarded mode-switch command
 * (`SwitchGewinnermittlungsartDto`) that seeds carry-over vouchers — never by
 * this ordinary save path.
 */
export class UpdateKontenrahmenSteuerartDto {
    kontenrahmen;
    sachkontenlaenge;
    versteuerungsart;
    /**
     * Justification for changing a *frozen* settings block (PRD #1319 / RS-003).
     * Required by the domain once the first export has completed; ignored
     * before the freeze. Recorded verbatim into the change history.
     */
    reason;
}
__decorate([
    IsOptional(),
    IsEnum(Kontenrahmen),
    __metadata("design:type", String)
], UpdateKontenrahmenSteuerartDto.prototype, "kontenrahmen", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(4),
    Max(8),
    __metadata("design:type", Number)
], UpdateKontenrahmenSteuerartDto.prototype, "sachkontenlaenge", void 0);
__decorate([
    IsOptional(),
    IsEnum(Versteuerungsart),
    __metadata("design:type", String)
], UpdateKontenrahmenSteuerartDto.prototype, "versteuerungsart", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(1000),
    __metadata("design:type", Object)
], UpdateKontenrahmenSteuerartDto.prototype, "reason", void 0);
//# sourceMappingURL=update-kontenrahmen-steuerart.dto.js.map